module.exports = __webpack_public_path__ + "static/media/main idea.76f98561.mp3";